export default "__VITE_ASSET__BT$2wkVY__"